<template>
  <div class="bg-white border topBar bg-white border topBar border-left-0 border-right-0">
    <div class="d-flex justify-content-between align-items-center ">
      <div class="lefticons d-flex">
        <template v-if="isStickerActive">
          <div class="px-2">
            <div class="border border-gray-300 rounded flex align-items-center justify-content-center relative">
              <div v-for="(color, index) in svgFillColors" :key="index" class="flex items-center mr-2">
                <input type="color" class="cursor-pointer box-content !rounded-full"
                  :style="{ backgroundColor: color, borderRadius: '100%', height: '23px', width: '23px', border: 'none', margin: '6px' }"
                  :value="color" @input="setSvgColor(index, $event)" @change="setSvgColor(index, $event)" />
              </div>

              <div style="height: 35px; width: 1px; background-color: #dee2e6;"></div>

              <div class="p-2 border-top-0 d-flex justify-content-center align-items-center">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer">
                  <path d="M13.0016 3L3 13M3 3L13.0016 13" stroke="#495057" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </template>

        <!-- Otherwise show the left icon toolbar -->
        <template v-else>
          <TextToolbar v-if="getActiveCanvasObject && !checkLock" />
          <span v-else>
            <span v-for="(Toolbarbtns, index) of Toolbarbtns" v-bind:key="index" @click="selectTool(Toolbarbtns.text)"
              :class="`iconBtn ${selectedTool === Toolbarbtns.text ? 'activeIconBtn' : ''} ${index !== 0 ? 'ml-3' : ''}`"
              v-b-tooltip.hover.bottom="Toolbarbtns.text" v-html="Toolbarbtns.icon">
            </span>
          </span>
        </template>
      </div>

      <div class="showonEachObject d-flex align-items-center">
        <div v-if="!checkLock"
          :class="`${transparency === true ? 'border' : 'border-transparent'} rounded flex px-4 pt-2 pb-495 position-relative`">
          <div v-if="transparency"
            class="flex items-center absolute right-full bg-white px-4 py-2 top-[-1px] bottom-[-1px] rounded-l-lg border-top border-left border-bottom rounded-left">
            <div class="text-xs">Transparency</div>
            <div class="w-28 mx-3 flex items-center">
              <div class="flex-1 pl-2">
                <input type="range" @input="showObjectTransparency($event)" class="form-control-range" value="100"
                  max="100" min="0" id="formControlRange">
              </div>
              <div class="pl-2 font-bold text-sm text-gray-700">{{ sliderValue }}</div>
            </div>
          </div>
          <img @click="showTransparency"
            src="data:image/png;base64,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"
            class="w-6 h-6 cursor-pointer" alt="Opacity">
        </div>
        <div v-if="!checkLock" class="">
          <b-dropdown id="dropdown-form" right ref="dropdown" class="noBG" no-caret>
            <template #button-content>
              Position <i class="fas fa-angle-down"></i> <i class="fas fa-angle-up"></i>
            </template>
            <div class="bg-white p-3  px-4  rounded-lg ">
              <div class="flex justify-around mb-4 text-center">
                <div @click="BrignForward" class="text-gray-700 cursor-pointer hover:text-blue-600 text-xs">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="m-auto w-4 h-4 mb-1">
                    <rect width="15" height="15" rx="2" fill="#DDE2E5"></rect>
                    <rect x="5" y="5" width="15" height="15" rx="2" fill="#495057"></rect>
                  </svg>
                  <div>Forward</div>
                </div>
                <div @click="SendBackward" class="text-gray-700 cursor-pointer hover:text-blue-600 text-xs">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="m-auto w-4 h-4 mb-1">
                    <rect width="15" height="15" rx="2" fill="#495057"></rect>
                    <rect x="5" y="5" width="15" height="15" rx="2" fill="#DDE2E5"></rect>
                  </svg>
                  <div>Backward</div>
                </div>
              </div>
              <div class="flex justify-around mb-4 text-center">
                <div @click="bringFronts" class="text-gray-700 cursor-pointer hover:text-blue-600 text-xs">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="m-auto w-4 h-4 mb-1">
                    <rect width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                    <rect x="12.5" y="12.5" width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                    <rect x="2.5" y="2.5" width="15" height="15" rx="2" fill="#212429"></rect>
                  </svg>
                  <div>Front</div>
                </div>
                <div @click="SendToBack" class="text-gray-700 cursor-pointer hover:text-blue-600 text-xs">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="m-auto w-4 h-4 mb-1">
                    <rect x="2.5" y="2.5" width="15" height="15" rx="2" fill="#212429"></rect>
                    <rect width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                    <rect x="12.5" y="12.5" width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                  </svg>
                  <div>Back</div>
                </div>
              </div>
              <div class="flex space-x-10">
                <div class="flex flex-col mr-5">
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="TopAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="8.5" y="9" width="6" height="16.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="17.5" y="9" width="6" height="10.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="4" y="6" width="24" height="1.5" rx="0.2" fill="currentColor"></rect>
                    </svg> Top
                  </div>
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="MiddleAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="8.5" y="8" width="6" height="16.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="17.5" y="11" width="6" height="10.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="4" y="15.5" width="24" height="1.5" rx="0.2" fill="currentColor"></rect>
                    </svg> Middle
                  </div>
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="BottomAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="8.5" y="6" width="6" height="16.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="17.5" y="12" width="6" height="10.5" rx="0.5" fill="currentColor"></rect>
                      <rect x="4" y="24" width="24" height="1.5" rx="0.2" fill="currentColor"></rect>
                    </svg> Bottom
                  </div>
                </div>
                <div class="flex flex-col ">
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="LeftAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="9" y="23.5" width="6" height="16.5" rx="0.5" transform="rotate(-90 9 23.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="9" y="14.5" width="6" height="10.5" rx="0.5" transform="rotate(-90 9 14.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="6" y="28" width="24" height="1.5" rx="0.2" transform="rotate(-90 6 28)"
                        fill="currentColor">
                      </rect>
                    </svg> Left
                  </div>
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="CenterAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="8" y="23.5" width="6" height="16.5" rx="0.5" transform="rotate(-90 8 23.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="11" y="14.5" width="6" height="10.5" rx="0.5" transform="rotate(-90 11 14.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="15.5" y="28" width="24" height="1.5" rx="0.2" transform="rotate(-90 15.5 28)"
                        fill="currentColor">
                      </rect>
                    </svg> Center
                  </div>
                  <div class="group text-gray-700 cursor-pointer hover:text-blue-600 flex items-center text-xs"
                    @click="RightAlign">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="group-hover:text-blue-600 text-gray-500 mr-2 w-6 h-6">
                      <rect x="22.5" y="17.5" width="6" height="16.5" rx="0.5" transform="rotate(90 22.5 17.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="22.5" y="8.5" width="6" height="10.5" rx="0.5" transform="rotate(90 22.5 8.5)"
                        fill="currentColor">
                      </rect>
                      <rect x="25.5" y="4" width="24" height="1.5" rx="0.2" transform="rotate(90 25.5 4)"
                        fill="currentColor">
                      </rect>
                    </svg> Right
                  </div>
                </div>
              </div>
            </div>
          </b-dropdown>
        </div>
        <div v-if="!checkLock" class="p-1 lockbtn lineheightminus iconBtn mx-2" @click="LockObj"
          v-b-tooltip.hover.bottom="`Lock (make unselectable)`">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
            class="w-5 h-5">
            <path fill="currentColor"
              d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2ZM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6Zm9 14H6V10h12v10Zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z">
            </path>
          </svg>
        </div>
        <div v-else class="p-1 lockbtn lineheightminus iconBtn mx-2" @click="unLockObj"
          v-b-tooltip.hover.bottom="`Unlock (make selectable)`">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
            class="flex-shrink-0">
            <path fill="currentColor"
              d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2Zm0 12H6V10h12v10Zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z">
            </path>
          </svg>
        </div>
        <div v-if="!checkLock" class="p-1 lineheightminus deletebtn mx-2" @click="deleteObjectFromCanvas">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.8089 1.52422C10.6029 0.889422 10.0724 0.47876 9.4707 0.47876H6.52834L6.4164 0.483273C6.12252 0.510925 5.84408 0.634403 5.61974 0.83657C5.3954 1.03874 5.23627 1.30956 5.16445 1.61147L4.98764 2.56065L4.96697 2.64414C4.92679 2.77638 4.84812 2.8919 4.74214 2.97426C4.63616 3.05663 4.50827 3.10165 4.37664 3.10294H2.10374L2.03315 3.1082C1.90697 3.12865 1.79202 3.19642 1.70938 3.29907C1.62674 3.40172 1.58197 3.53237 1.58328 3.66703C1.58328 3.97841 1.81642 4.23113 2.10445 4.23113H13.896L13.9666 4.22586C14.0927 4.20543 14.2075 4.13778 14.2901 4.03528C14.3728 3.93279 14.4176 3.80232 14.4165 3.66778C14.4174 3.59463 14.4047 3.522 14.379 3.45404C14.3533 3.38608 14.3152 3.32414 14.2668 3.27175C14.2183 3.21935 14.1606 3.17754 14.0969 3.14871C14.0332 3.11987 13.9647 3.10457 13.8953 3.10369H11.6231L11.5433 3.09842C11.4125 3.0789 11.2908 3.01658 11.1954 2.92023C11.1 2.82389 11.0356 2.69838 11.0114 2.5614L10.8424 1.64682L10.8082 1.52497L10.8089 1.52422ZM10.0774 3.10369C10.0535 3.03927 10.033 2.97348 10.0161 2.90663L9.98902 2.78178L9.82789 1.90179C9.81033 1.82867 9.77314 1.76246 9.72078 1.71109C9.66843 1.65973 9.60313 1.6254 9.53273 1.61222L9.47142 1.60695H6.52834C6.46052 1.60699 6.39399 1.62646 6.33585 1.66329C6.27771 1.70012 6.23014 1.75292 6.19824 1.81604L6.1797 1.86719L6.01073 2.78178C5.98934 2.89309 5.96011 3.00065 5.92233 3.10294H10.0774V3.10369ZM12.9749 5.53306C13.2387 5.55563 13.4397 5.78653 13.454 6.06407L13.4469 6.21901L13.223 9.11545L12.9877 11.942C12.9378 12.506 12.8936 12.9829 12.8551 13.3575C12.7211 14.6632 11.9183 15.4709 10.707 15.4943C8.886 15.5315 7.06451 15.5303 5.24359 15.4905C4.06722 15.4642 3.27584 14.6481 3.14465 13.362L3.05339 12.415L2.89512 10.5776L2.73256 8.56189L2.5472 6.14003C2.53469 5.99282 2.57791 5.84636 2.6674 5.73264C2.7569 5.61892 2.88541 5.54718 3.02488 5.53306C3.28867 5.5105 3.52109 5.70305 3.57599 5.97456L3.59738 6.19644L3.77205 8.46561L3.96241 10.8175C4.04797 11.8359 4.1214 12.6602 4.18058 13.2386C4.25544 13.9712 4.62118 14.348 5.26498 14.3623C7.01315 14.4022 8.81407 14.4029 10.6877 14.3661C11.3707 14.3525 11.7422 13.9795 11.8185 13.2326L11.909 12.2909C11.9354 12.0006 11.9632 11.6795 11.9931 11.3312L12.1842 9.01843L12.4138 6.05053C12.4221 5.91603 12.4764 5.7893 12.5666 5.69385C12.6569 5.59841 12.7768 5.54074 12.9043 5.53156L12.9756 5.53306H12.9749Z"
              fill="currentColor"></path>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.8089 1.52422C10.6029 0.889422 10.0724 0.47876 9.4707 0.47876H6.52834L6.4164 0.483273C6.12252 0.510925 5.84408 0.634403 5.61974 0.83657C5.3954 1.03874 5.23627 1.30956 5.16445 1.61147L4.98764 2.56065L4.96697 2.64414C4.92679 2.77638 4.84812 2.8919 4.74214 2.97426C4.63616 3.05663 4.50827 3.10165 4.37664 3.10294H2.10374L2.03315 3.1082C1.90697 3.12865 1.79202 3.19642 1.70938 3.29907C1.62674 3.40172 1.58197 3.53237 1.58328 3.66703C1.58328 3.97841 1.81642 4.23113 2.10445 4.23113H13.896L13.9666 4.22586C14.0927 4.20543 14.2075 4.13778 14.2901 4.03528C14.3728 3.93279 14.4176 3.80232 14.4165 3.66778C14.4174 3.59463 14.4047 3.522 14.379 3.45404C14.3533 3.38608 14.3152 3.32414 14.2668 3.27175C14.2183 3.21935 14.1606 3.17754 14.0969 3.14871C14.0332 3.11987 13.9647 3.10457 13.8953 3.10369H11.6231L11.5433 3.09842C11.4125 3.0789 11.2908 3.01658 11.1954 2.92023C11.1 2.82389 11.0356 2.69838 11.0114 2.5614L10.8424 1.64682L10.8082 1.52497L10.8089 1.52422ZM10.0774 3.10369C10.0535 3.03927 10.033 2.97348 10.0161 2.90663L9.98902 2.78178L9.82789 1.90179C9.81033 1.82867 9.77314 1.76246 9.72078 1.71109C9.66843 1.65973 9.60313 1.6254 9.53273 1.61222L9.47142 1.60695H6.52834C6.46052 1.60699 6.39399 1.62646 6.33585 1.66329C6.27771 1.70012 6.23014 1.75292 6.19824 1.81604L6.1797 1.86719L6.01073 2.78178C5.98934 2.89309 5.96011 3.00065 5.92233 3.10294H10.0774V3.10369ZM12.9749 5.53306C13.2387 5.55563 13.4397 5.78653 13.454 6.06407L13.4469 6.21901L13.223 9.11545L12.9877 11.942C12.9378 12.506 12.8936 12.9829 12.8551 13.3575C12.7211 14.6632 11.9183 15.4709 10.707 15.4943C8.886 15.5315 7.06451 15.5303 5.24359 15.4905C4.06722 15.4642 3.27584 14.6481 3.14465 13.362L3.05339 12.415L2.89512 10.5776L2.73256 8.56189L2.5472 6.14003C2.53469 5.99282 2.57791 5.84636 2.6674 5.73264C2.7569 5.61892 2.88541 5.54718 3.02488 5.53306C3.28867 5.5105 3.52109 5.70305 3.57599 5.97456L3.59738 6.19644L3.77205 8.46561L3.96241 10.8175C4.04797 11.8359 4.1214 12.6602 4.18058 13.2386C4.25544 13.9712 4.62118 14.348 5.26498 14.3623C7.01315 14.4022 8.81407 14.4029 10.6877 14.3661C11.3707 14.3525 11.7422 13.9795 11.8185 13.2326L11.909 12.2909C11.9354 12.0006 11.9632 11.6795 11.9931 11.3312L12.1842 9.01843L12.4138 6.05053C12.4221 5.91603 12.4764 5.7893 12.5666 5.69385C12.6569 5.59841 12.7768 5.54074 12.9043 5.53156L12.9756 5.53306H12.9749Z"
              stroke="currentColor" stroke-width="0.461538"></path>
          </svg>
        </div>
        <div>
          <div>
            <!-- Layers Icon Button -->
            <div class="p-1 layers-btn mx-2" @click="toggleLayersPanel" :class="{ 'active-layer': isLayersVisible }">
              <svg width="16" height="16" style="margin-left: 5px;" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 0L15 4L8 8L1 4L8 0ZM8 9L1 5V8L8 12L15 8V5L8 9ZM8 13L1 9V12L8 16L15 12V9L8 13Z"
                  fill="currentColor" />
              </svg>

              <i v-if="!isLayersVisible" class="fa-solid fa-caret-left font-12 ml-2"></i>
              <i v-else class="fa-solid fa-caret-right font-12 ml-2"></i>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultToolbar } from "../../commonJSON";
import TextToolbar from "./Texttoolbar.vue";
// import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'DefaultToolbar',
  data() {
    return {
      Toolbarbtns: DefaultToolbar,
      activeShape: null,
      transparency: false,
      sliderValue: 100,
      line: "",
      isDown: false,
      mode: "selection",
      selectedTool: null,
      bgColor: '#000000',
      svgFillColors: ['#000000'],
    }
  },
  components: {
    TextToolbar,
  },
  computed: {
    // Returns true if the active object id includes 'Stickers_'
    isStickerActive() {
      const obj = this.getActiveCanvasObj;
      return obj && obj.id && obj.id.includes('Stickers_');
    },
    getActiveCanvas() {
      return this.$store.getters.getCurrentActiveCanvas
    },
    getcreateShapeType() {
      return this.$store.getters.getcreateShapeType
    },
    getActiveCanvasObjectsList() {
      return this.$store.getters.getCurrentActiveCanvasObjects
    },
    getActiveCanvasObject() {
      let obj = this.$store.getters.getActiveObject && this.$store.getters.getActiveObject.target;
      let type = !!obj && obj.getAttribute("data-type");


      if (obj !== null && type !== null && type == "text") {

        return true
      } else {
        return false
      }
    },
    getActiveCanvasObj() {
      return this.$store.getters.getActiveObject
    },
    getActiveCanvasObjProps() {
      return this.$store.getters.getActiveObjectprops
    },
    checkLock() {
      let obj = this.$store.getters.getActiveObjectprops;

      if (obj !== null && obj?.lock == true) {
        return true
      } else {
        return false
      }
    },
    getZoom() {
      return this.$store.getters.getZoom
    },

    isLayersVisible() {
      return this.$store.getters.getShowLayersPanel;
    }
  }, watch: {
    getcreateShapeType(newValue) {
      console.log('Canvas updated', newValue);
      this.activeShape = newValue;

      // Sync selectedTool with shape type (for keyboard shortcut)
      this.selectedTool = newValue;

    },
    getActiveCanvasObjProps(newValue) {
      console.log('Active Canvas Obj', newValue);
    },
    getActiveCanvasObj: {
      handler() {
        this.updateColorFromActiveObject();
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    updateColorFromActiveObject() {
      const obj = this.getActiveCanvasObjProps;
      if (!obj || !obj.id) {
        this.svgFillColors = ['#000000'];
        return;
      }

      if (obj.fillColors && Array.isArray(obj.fillColors)) {
        this.svgFillColors = obj.fillColors;
      } else {
        // Detect fill colors from DOM if not in state
        const el = document.querySelector(`[data-id-t="${obj.id}"]`);
        if (el) {
          this.svgFillColors = this.detectSvgFillColors(el);
        } else {
          this.svgFillColors = ['#000000'];
        }
      }
    },

    detectSvgFillColors(svgElement) {
      const fills = [];
      const paths = svgElement.querySelectorAll('path, circle, rect, polygon, ellipse');

      paths.forEach((el) => {
        const fill = el.getAttribute('fill');
        if (fill && !fills.includes(fill)) {
          fills.push(fill);
        }
      });

      return fills.length ? fills : ['#000000'];
    },

    injectMultipleFillsToSvg(svgElement, fillColors = ['#000000']) {
      if (!svgElement) return;
      const paths = svgElement.querySelectorAll('path, circle, rect, polygon, ellipse');

      paths.forEach((el, index) => {
        const colorToApply = fillColors[index] || fillColors[0] || '#000000';
        el.setAttribute('fill', colorToApply);

        if (el.hasAttribute('style')) {
          const style = el.getAttribute('style');
          const cleanedStyle = style.replace(/fill:\s*[^;]+/gi, `fill: ${colorToApply}`);
          el.setAttribute('style', cleanedStyle);
        }
      });

      svgElement.setAttribute('fill', fillColors[0]);
      if (svgElement.style) svgElement.style.fill = fillColors[0];
    },

    setSvgColor(index, event) {
      const newColor = event.target.value;
      const obj = this.getActiveCanvasObj;
      if (!obj || !obj.id || !obj.id.includes('Stickers_')) return;

      const stickerId = obj.id;
      const el = document.querySelector(`[data-id-t="${stickerId}"]`);
      if (!el) return;

      const updatedFills = [...this.svgFillColors];
      updatedFills[index] = newColor;
      this.svgFillColors = updatedFills;

      this.injectMultipleFillsToSvg(el, updatedFills);

      this.$store.dispatch('setCurrentObjectProperties', {
        id: stickerId,
        fillColors: updatedFills,
      });
    },

    handleToolbarShortcut(e) {
      // Only respond if not typing in an input/textarea
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) return;
      if (e.key === 't' || e.key === 'T') {
        this.selectedTool = 'Text';
        this.$store.dispatch('createShape', 'Text');
        this.activeShape = 'Text';
      }
    },

    selectTool(tool) {
      this.selectedTool = tool;
      this.$store.dispatch('createShape', tool);
      this.activeShape = tool;
    },

    toggleLayersPanel() {
      console.log(this.isLayersVisible)
      this.$store.dispatch("toggleLayerPanel", !this.isLayersVisible);
    },

    SendToBack() {
      let currentTarget = this.getActiveCanvasObj.id;
      if (currentTarget) {
        let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
        let value = { oldindex, newIndex: 0 }
        this.$store.dispatch("zIndexObjects", value)
      }

    },
    bringFronts() {


      let currentTarget = this.getActiveCanvasObj.id;
      if (currentTarget) {
        let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);

        let value = { oldindex, newIndex: this.getActiveCanvasObjectsList.length - 1 }
        this.$store.dispatch("zIndexObjects", value)
      }
    },
    SendBackward() {
      let currentTarget = this.getActiveCanvasObj.id;
      if (currentTarget) {
        let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
        if (parseInt(oldindex) !== 0) {
          let value = { oldindex, newIndex: parseInt(oldindex) - 1 }
          this.$store.dispatch("zIndexObjects", value)
        }

      }
    },
    BrignForward() {
      let currentTarget = this.getActiveCanvasObj.id;
      let objlist = this.getActiveCanvasObjectsList;
      if (currentTarget) {
        let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
        if (parseInt(oldindex) !== (objlist.length - 1)) {
          let value = { oldindex, newIndex: parseInt(oldindex) + 1 }
          this.$store.dispatch("zIndexObjects", value)
        }

      }
    },
    showTransparency() {
      this.transparency = !this.transparency
    },
    deleteObjectFromCanvas() {

      let currentObj = this.getActiveCanvasObj;
      if (currentObj != null) {
        this.$store.dispatch("deleteObject", currentObj.id);
      }

    },

    toggleSidebar() {
      this.isLayersVisible = !this.isLayersVisible; // Toggle visibility state
    },
    hideSidebar() {
      this.isLayersVisible = false; // Method to hide the sidebar when close is clicked
    },

    LockObj() {
      this.$store.dispatch("setCurrentObjectProperties", { lock: true });
    },
    unLockObj() {
      this.$store.dispatch("setCurrentObjectProperties", { lock: false });
    },
    showObjectTransparency(e) {

      let value = e.target.value;
      this.sliderValue = value;

      let currentObj = this.getActiveCanvasObj;
      if (currentObj != null) {
        this.$store.dispatch("setCurrentObjectProperties", { opacity: value / 100 });
      }

    },

    TopAlign() {


      var activeObject = this.getActiveCanvasObj;
      if (activeObject != null) {
        this.$store.dispatch("setCurrentObjectProperties", { top: 0 });

      }


    },
    BottomAlign() {
      debugger // eslint-disable-line no-debugger
      let canvas = this.getActiveCanvas;
      var activeObject = this.getActiveCanvasObj;
      let activeObjProps = this.getActiveCanvasObjProps;
      if (!!canvas && activeObject != null) {
        // this.$store.dispatch("setCurrentObjectProperties" , { top: (canvas.size.height - (activeObject.target.clientHeight)) });
        this.$store.dispatch("setCurrentObjectProperties", { top: (canvas.size.height - (activeObjProps.height)) });
      }


    },
    LeftAlign() {
      var activeObject = this.getActiveCanvasObj;
      if (activeObject != null) {
        this.$store.dispatch("setCurrentObjectProperties", { left: 0 });

      }

    },
    RightAlign() {

      let canvas = this.getActiveCanvas;
      var activeObject = this.getActiveCanvasObj;
      let activeObjProps = this.getActiveCanvasObjProps;

      if (!!canvas && activeObject != null) {
        // this.$store.dispatch("setCurrentObjectProperties" , { left: (canvas.size.width - this.getActiveCanvasObjProps.width )});
        this.$store.dispatch("setCurrentObjectProperties", { left: (canvas.size.width - activeObjProps.width) });
      }

    },
    MiddleAlign() {

      let canvas = this.getActiveCanvas;
      var activeObject = this.getActiveCanvasObj;
      let activeObjProps = this.getActiveCanvasObjProps;

      if (!!canvas && activeObject != null) {
        // this.$store.dispatch("setCurrentObjectProperties" , { top: (canvas.size.height / 2 ) - (activeObject.target.clientHeight / 2)});
        this.$store.dispatch("setCurrentObjectProperties", { top: (canvas.size.height / 2) - (activeObjProps.height / 2) });
      }


    },
    CenterAlign() {


      let canvas = this.getActiveCanvas;
      var activeObject = this.getActiveCanvasObj;
      let activeObjProps = this.getActiveCanvasObjProps;
      if (!!canvas && activeObject != null) {
        let value = (canvas.size.width / 2) - (activeObjProps.width / 2);
        this.$store.dispatch("setCurrentObjectProperties", { left: value });
      }


    },
    addShape(check) {
      this.selectedTool = check;
      this.$store.dispatch('createShape', check);
      this.activeShape = check;
      // this.activeShape = index;
      //         if(check === "Text"){
      //         this.$store.dispatch("addObjectInCanvas" ,
      //         {
      //             id:`text_${uuidv4()}`,
      //             type:'text',
      //             text:"Welcome !",
      //             top:10,
      //             left:150,
      //             scaleX:1,
      //             scaleY:1,
      //             zoom:1,
      //             width:150,
      //             color:"#565d64",
      //             height:100,
      //             opacity:1,
      //             fw:400,
      //             fs:24,
      //             align:"center",
      //             fontfamily:'default',
      //             italic:false,
      //             underline:false,
      //             lock:false

      //         }
      //         )

      //         } else if (check === "Ellipse"){
      //           this.$store.dispatch("addObjectInCanvas" ,
      //         {
      //             id:`ellipse_${uuidv4()}`,
      //             type:'Ellipse',
      //             top:100,
      //             left:100,
      //             scaleX:1,
      //             scaleY:1,
      //             zoom:1,
      //             width:60,
      //             color:"#565d64",
      //             bgColor:"#a2a5a9",
      //             borderRadius: 50,
      //             height:60,
      //             opacity:1,
      //             lock:false,
      //             borderColor:"#2f5479",
      //             borderWidth:2
      //         }
      //         )

      //         } else if (check === "Triangle"){
      //           this.$store.dispatch("addObjectInCanvas" ,
      //         {
      //             id:`triangle_${uuidv4()}`,
      //             type:'Triangle',
      //             top:150,
      //             left:150,
      //             scaleX:1,
      //             scaleY:1,
      //             zoom:1,
      //             width:60,
      //             bgColor:"#a2a5a9",
      //             height:100,
      //             opacity:1,
      //             lock:false,
      //             clip:`polygon(0% 0%, 100% 0%, 50% 100%)`
      //         }
      //         )
      //         }
      //          else if (check === "Rectangle"){
      //           this.$store.dispatch("addObjectInCanvas" ,
      //         {
      //             id:`rectangle_${uuidv4()}`,
      //             type:'Rectangle',
      //             top:100,
      //             left:100,
      //             scaleX:1,
      //             scaleY:1,
      //             zoom:1,
      //             width:60,
      //             bgColor:"#a2a5a9",
      //             borderRadius: 0,
      //             height:60,
      //             opacity:1,
      //             lock:false,
      //             borderColor:"#2f5479",
      //             borderWidth:2
      //         }
      //         )

      //           // var rectangle = new fabric.Rect({
      //           //     top:80,
      //           //     left:80,
      //           //       width: 200,
      //           //       height: 100,
      //           //       fill: 'red',
      //           //       stroke: 'red',
      //           //       strokeWidth: 3
      //           //   });

      //     // Render the Rect in canvas
      //     // canvas.add(rectangle);
      //         } else {
      //           this.$store.dispatch("addObjectInCanvas" ,
      //         {
      //             id:`line_${uuidv4()}`,
      //             type:'Line',
      //             top:130,
      //             left:140,
      //             scaleX:1,
      //             scaleY:1,
      //             zoom:1,
      //             width:2,
      //             bgColor:"#a2a5a9",
      //             borderRadius: 0,
      //             height:120,
      //             opacity:1,
      //             lock:false,
      //             borderColor:"#2f5479",
      //             borderWidth:2
      //         }
      //         )
      //           //let canvas = this.getActiveCanvas;
      //  // drawLineOnSelections(canvas)

      //         }



    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleToolbarShortcut);
    // Initialize selectedTool from store if needed
    this.selectedTool = this.getcreateShapeType;
    this.updateColorFromActiveObject();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleToolbarShortcut);
  }
}

</script>

<style scoped>
.form-control-range {
  height: 2.19px;
  border: 0;
}

.pb-495 {
  padding-bottom: 0.49rem !important;
}

.w-28 {
  width: 7rem;
}

.cursor-pointer {
  cursor: pointer;
}

.w-6 {
  width: 1.5rem;
}

.h-6 {
  height: 1.5rem;
}

.topBar>div {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: .65rem;
  padding-top: .65rem;
}

.hover\:text-blue-600:hover {
  color: rgb(66 99 235);
  cursor: pointer;
}

.text-xs {
  font-size: .75rem;
  line-height: 1rem;
}

.flex {
  display: flex;
}

.justify-around {
  justify-content: space-around;
}

.items-center {
  align-items: center;
}

.lineheightminus {
  line-height: 1px;
}

.iconBtn:hover {
  color: rgb(172 181 189) !important;
  cursor: pointer;
}

.flex-col {
  flex-direction: column;
}

.deletebtn:hover {
  color: red;
  cursor: pointer;
}

.items-center {
  align-items: center;
}

.flex {
  display: flex;
}

.bottom-\[-1px\] {
  bottom: -1px;
}

.top-\[-1px\] {
  top: -1px;
}

.right-full {
  right: 100%;
}

.absolute {
  position: absolute;
}

.layers-btn {
  cursor: pointer;
}

.font-12 {
  font-size: 12px;
}

.active-layer {
  background-color: #d3d3d3;
  /* Set the background color when active */
  border-radius: 5px;
  /* Optional: Add some rounding to the corners */
  height: 35px;
  width: 50px;
}
</style>
